import { Inject, Injectable } from "@angular/core";
import { Params } from "@angular/router";
import { PERSONAL_DASHBOARD_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { IUserMenuItem } from "@common/shell/application-bar-user-item-content/user-menu-item";
import { AuthorisationNotificationService } from "@org-common/lib/authorisation/authorisation-notification.service";
import { DirectoryAuthService } from "@org-common/lib/directory-shared/directory-auth.service";
import { OrganisationService } from "@org-common/lib/organisation/organisation.service";
import { combineLatest, Observable } from "rxjs";
import { filter, map, startWith, switchMap } from "rxjs/operators";

@Injectable()
export class PersonalDashboardUserMenuItem implements IUserMenuItem {
    public text = "Personal dashboard";
    public icon = "fal fa-dashboard";
    public testAttribute = "dashboard";
    public href$: Observable<string>;
    public isShown$: Observable<boolean>;

    public constructor(
        orgService: OrganisationService,
        directoryAuthService: DirectoryAuthService,
        authNotificationService: AuthorisationNotificationService,
        @Inject(PERSONAL_DASHBOARD_PAGE) dashboardPageRoute: IAdaptRoute<Params, Params>,
    ) {
        // Organisation initialisation happens after the user is already initialised so don't
        // bother updating when the user changes. This also handles an organisation switch
        // correctly too.
        this.href$ = orgService.currentOrganisation$.pipe(
            filter((org) => !!org),
            switchMap(() => dashboardPageRoute.getRoute()),
        );
        this.isShown$ = combineLatest([
            orgService.currentOrganisation$,
            authNotificationService.authorisationChanged$.pipe(
                startWith(undefined),
            ),
        ]).pipe(
            map(([org]) => !!org && directoryAuthService.currentPersonCanReadTheirProfile()),
        );
    }
}
